import React from 'react';
import clsx from 'clsx';
import { ReactComponent as IconCalendar } from 'images/calendar.svg';
import { ReactComponent as IconArrow } from 'images/arrow-down-w.svg';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import format from 'date-fns/format'
import styles from './Input.module.scss';
import dateStyles from './DateInput.module.scss';

function CustomInput(props: any) {
  const {
    white, onClick, noIcon, valueString, withArrow,
  } = props
  return (
    <div
      className={clsx(
        dateStyles.datepickerInput,
        white && dateStyles.datepickerInputWhite,
        noIcon && dateStyles.datepickerInputNoIcon,
      )}
      onClick={onClick}
    >
      <div className={dateStyles.datepickerInputInner}>
        {noIcon ? null : (<IconCalendar className={styles.prefixDate} />)}
        <span className={dateStyles.datepickerSpan}>{valueString}</span>
        {withArrow ? (<IconArrow className={dateStyles.datepickerArrow} />) : null}
      </div>
    </div>
  )
}

type InputProps = {
  className?: string,
  pickerClassName?: string,
  onChange?: (value: Date | null) => void,
  value?: Date | null,
  disabled?: boolean,
  error?: boolean,
  errorMessage?: string,
  onBlur?: () => void,
  white?: boolean,
  wide?: boolean,
  noIcon?: boolean,
  dateFormat?: string,
  withArrow?: boolean,
  allDates?: boolean,
  fromDate?: Date,
}

function Input({
  className = '',
  pickerClassName = '',
  onChange = () => {},
  value = null,
  disabled = false,
  error = false,
  errorMessage = '',
  white = false,
  wide = false,
  noIcon = false,
  dateFormat = 'MM.dd.yyyy',
  withArrow = false,
  allDates = false,
  fromDate,
  ...restInputProps
}: InputProps) {
  let valueString;
  if (value && !fromDate) {
    const yesterdayDate = new Date();
    yesterdayDate.setDate(yesterdayDate.getDate() - 1);
    const today = format(new Date(), 'MM.dd.yyyy');
    const yesterday = format(yesterdayDate, 'MM.dd.yyyy');
    const currentDay = format(value, 'MM.dd.yyyy');
    valueString = format(value, dateFormat);

    if (currentDay === today) {
      valueString = 'Today';
    }
    if (currentDay === yesterday) {
      valueString = 'Yesterday';
    }
  }

  if (fromDate) {
    const fromDateCurrent = new Date(fromDate);
    const lastDay = new Date(fromDateCurrent).getDate() + 6;
    const toDate = new Date(new Date(fromDateCurrent).setDate(lastDay))
    if (fromDateCurrent.getMonth() === toDate.getMonth()) {
      valueString = `${format(fromDateCurrent, 'MMM d')}-${format(toDate, 'd')}`
    } else {
      valueString = `${format(fromDateCurrent, 'MMM d')} - ${format(toDate, 'MMM d')}`
    }
  }
  return (
    <>
      <div
        className={clsx(
          dateStyles.containerDate,
          wide && styles.containerWide,
          className,
          disabled && styles.containerDisabled,
          !value && styles.containerEmpty,
          error && styles.error,
          white && styles.containerWhite,
          white && dateStyles.containerDateWhite,
        )}
      >
        {/* @ts-ignore */}
        <DatePicker
          className={clsx(
            styles.inputDate,
            white && 'react-datepicker--white',
          )}
          popperClassName={clsx(white ? 'react-datepicker-popper--white' : undefined, pickerClassName)}
          wrapperClassName={white ? 'react-datepicker-wrapper--white' : undefined}
          selected={value}
          onChange={(date) => onChange(date)}
          disabled={disabled}
          dateFormat={dateFormat}
          customInput={(
            <CustomInput
              noIcon={noIcon}
              white={white}
              valueString={valueString}
              withArrow={withArrow}
            />
          )}
          maxDate={!allDates ? new Date() : null}
          {...restInputProps}
        />
      </div>
      {(error && errorMessage) && (
        <div className={styles.errorMessage}>{errorMessage}</div>
      )}
    </>
  )
}

export default Input
